import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { AlertService } from "../../services/alert.service";
import { CustomValidator } from "../../customValidator/custom-validator";
import { SecurityValidators } from "../../customValidator/security-validators";

@Component({
  selector: "app-change-password-dialog",
  templateUrl: "./change-password-dialog.component.html",
  styleUrls: ["./change-password-dialog.component.scss"],
})
export class ChangePasswordDialogComponent implements OnInit {
  saveEvent?: (password: string, confirmPassword: string) => void;
  passwordControl = new FormControl("", [
    Validators.required,
    // Backend Password() rule: 8+ chars, upper, lower, digit, any non-alphanumeric.
    SecurityValidators.backendPassword(),
  ]);
  confirmPasswordControl = new FormControl("", [
    Validators.required,
    CustomValidator.PasswordMatch(this.passwordControl),
  ]);
  passwordGroup = new FormGroup({
    password: this.passwordControl,
    confirmPassword: this.confirmPasswordControl,
  });

  constructor(
    private alertService: AlertService,
    private ngbActiveModal: NgbActiveModal,
  ) {}

  ngOnInit(): void {}
  get isSaving(): boolean {
    return this.alertService.isLoadingInProgress;
  }
  // tslint:disable-next-line:typedef
  close() {
    this.ngbActiveModal.close();
  }
  // tslint:disable-next-line:typedef
  save() {
    if (this.passwordGroup?.valid) {
      if (this.saveEvent) {
        this.saveEvent(
          this.passwordControl.value ?? "",
          this.confirmPasswordControl.value ?? "",
        );
      }
    } else {
      this.alertService.showErrorMessage("Please fill all the required values");
    }
  }
}
